
import Home from '@/components/pages/Home/Home';
import {createBrowserRouter,RouteObject} from 'react-router-dom';
export const routes:RouteObject[] = [  {
    path: '/',
    element: <Home />,
  },];
  let router = createBrowserRouter(routes);
export const manipulateRoutes = (route:RouteObject )=> {
    routes.push(route)
}

export const recreateRouter = () => {
    router = createBrowserRouter(routes);
};

export const getRouter = () => router;